import { render, staticRenderFns } from "./TagEditCreate.vue?vue&type=template&id=21accdfe&"
import script from "./TagEditCreate.vue?vue&type=script&lang=js&"
export * from "./TagEditCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports